import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { Position } from '@xyflow/react';
import ActionHandle from '../ActionHandle';
import { ActionTurnOffLEDNodeType } from '../types';
import BaseNode from '../BaseNode';
import { getLEDText, getActionText } from '../../util/generateLEDNames';

export const ActionTurnOffLEDNode = memo(
  ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    data,
    selected,
    disabled,
  }: {
    data: ActionTurnOffLEDNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();

    const { leds, rampDownDuration } = data.options;

    const ledText = getLEDText(leds);
    const actionText = getActionText(
      intl,
      false,
      false,
      true,
      rampDownDuration,
    );

    const text = `${ledText}${actionText}`;

    return (
      <BaseNode
        selected={selected ?? false}
        type="action"
        isValid={data.isValid}
        disabled={disabled}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Turn Off LED',
              id: 'uHJm2I',
            })}
          </T>
          <T body2>{text}</T>
        </Flex>
        <ActionHandle
          type="target"
          position={Position.Left}
          disabled={disabled}
        />
        <ActionHandle
          type="source"
          position={Position.Right}
          disabled={disabled}
        />
      </BaseNode>
    );
  },
);
